import { ValidationStatus } from 'signup-ui-lego-core/types';
export const syncPhoneValidator = phoneNumber => {
  if (!phoneNumber || phoneNumber.length <= 4) {
    return ValidationStatus.INVALID;
  }
  return ValidationStatus.VALID;
};